export const CLIENT_AUTH_STORAGE_KEY = "alphasniper_client";

function readRawFromStorage() {
  let raw = localStorage.getItem(CLIENT_AUTH_STORAGE_KEY);
  if (!raw) {
    raw = sessionStorage.getItem(CLIENT_AUTH_STORAGE_KEY);
    if (raw) {
      localStorage.setItem(CLIENT_AUTH_STORAGE_KEY, raw);
      sessionStorage.removeItem(CLIENT_AUTH_STORAGE_KEY);
    }
  }
  return raw;
}

export function readClientSession() {
  try {
    const raw = readRawFromStorage();
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (s?.clientId != null) return s;
  } catch {
    /* ignore */
  }
  return null;
}

export function saveClientSession(payload) {
  sessionStorage.removeItem(CLIENT_AUTH_STORAGE_KEY);
  localStorage.setItem(CLIENT_AUTH_STORAGE_KEY, JSON.stringify(payload));
}

export function clearClientSession() {
  localStorage.removeItem(CLIENT_AUTH_STORAGE_KEY);
  sessionStorage.removeItem(CLIENT_AUTH_STORAGE_KEY);
}
